import { FieldProps } from 'formik';
import * as React from 'react';
import { string } from 'yup';
import ErrorTextField from './ErrorTextField';

interface FormFieldProps extends FieldProps {
	required?: boolean;
}

const City: React.StatelessComponent<FormFieldProps> = function (props) {
	const {
		form: { errors, touched },
		field,
		required,
	} = props;
	const name = field.name;

	return <ErrorTextField
		errorMessage={touched[name] ? errors[name] as string : undefined}
		label='City'
		required={required}
		{...field}
	/>;
};

export function cityValidation (required: boolean = false) {
	const value = string();

	if (required) {
		return value.required('Please enter your city.');
	}

	return value;
}

export default City;
